import React, {
  Suspense,
  lazy,
  createContext,
  useState,
  useEffect,
} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Spinner from "./components/Base/Spinner/Spinner";
import "./App.css";

export const AppDataContext = createContext(null);

const MainWindow = lazy(() =>
  import("./components/Containers/CMainWindow/CMainWindow")
);

export default function App() {
  const [component, setComponent] = useState("ChildComponent1");
  const [user, setUser] = useState(null);
  const [debugMode, setDebugMode] = useState(
    process.env.REACT_APP_DEBUG_MODE === "true"
  );
  const [cartItems, setCartItems] = useState([]);

  const showCode = true;

  // Get environment variables for routing configuration
  const rootRedirectUrl = process.env.REACT_APP_ROOT_REDIRECT_URL;
  const linksRoute = process.env.REACT_APP_LINKS_ROUTE || "/links";

  // WordPress configuration
  const enableWordpress = process.env.REACT_APP_ENABLE_WORDPRESS === "true";
  const wordpressUrl = process.env.REACT_APP_WORDPRESS_URL;
  const wordpressRoute = process.env.REACT_APP_WORDPRESS_ROUTE || "/site";
  const forceWordpressRedirect =
    process.env.REACT_APP_FORCE_WORDPRESS_REDIRECT === "true";

  useEffect(() => {
    if (showCode === true) {
      debugMode === true
        ? console.log("MAIN DEBUG SWITCH : ON")
        : console.log("MAIN DEBUG SWITCH : OFF");
    }
    setComponent("ChildComponent1");
  }, [debugMode, showCode]);

  const appData = {
    user,
    setUser,
    debugMode,
    setDebugMode,
    cartItems,
    setCartItems,
    component,
    setComponent,
  };

  return (
    <>
      <AppDataContext.Provider value={appData}>
        <Router>
          <Suspense fallback={<Spinner />}>
            <Routes>
              <Route
                path="/"
                element={
                  forceWordpressRedirect && wordpressUrl ? (
                    <WordPressRedirect
                      wordpressUrl={wordpressUrl}
                      wordpressRoute={wordpressRoute}
                    />
                  ) : rootRedirectUrl ? (
                    <RootRedirect url={rootRedirectUrl} />
                  ) : (
                    <MainWindow
                      setComponent={() => setComponent("ChildComponent1")}
                    />
                  )
                }
              />
              <Route
                path={linksRoute}
                element={
                  <MainWindow
                    setComponent={() => setComponent("ChildComponent1")}
                  />
                }
              />

              {/* WordPress route - redirects to subdomain when enabled */}
              {enableWordpress && wordpressUrl && (
                <Route
                  path={`${wordpressRoute}/*`}
                  element={
                    <WordPressRedirect
                      wordpressUrl={wordpressUrl}
                      wordpressRoute={wordpressRoute}
                    />
                  }
                />
              )}

              {/* Handle /sites route to prevent redirect loops */}
              <Route
                path="/sites"
                element={<SitesRedirect wordpressUrl={wordpressUrl} />}
              />

              <Route
                path="/comingSoon"
                element={
                  <MainWindow
                    setComponent={() => setComponent("ChildComponent3")}
                  />
                }
              />
              <Route
                path="/Test"
                element={
                  <MainWindow
                    setComponent={() => setComponent("ChildComponent5")}
                  />
                }
              />
              <Route
                path="/qr"
                element={
                  <MainWindow
                    setComponent={() => setComponent("ChildComponent7")}
                  />
                }
              />
              <Route path="/amazon_store" element={<NaiStore />} />
              <Route
                path="*"
                element={
                  <NotFound debugMode={debugMode} setComponent={setComponent} />
                }
              />
            </Routes>
          </Suspense>
        </Router>
      </AppDataContext.Provider>
    </>
  );
}

function RootRedirect({ url }) {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <Spinner />
    </div>
  );
}

function NaiStore() {
  // 👇️ using window.location.href 👇️
  window.location.href = "https://holisticlifeheal.com/amazon_store/index.html";
  return null;
}

function WordPressRedirect({ wordpressUrl, wordpressRoute }) {
  useEffect(() => {
    if (wordpressUrl) {
      window.location.href = wordpressUrl;
    } else {
      // Fallback to main site if WordPress URL is not configured
      //console.warn("WordPress URL not configured, redirecting to main site");
      window.location.href = "/";
    }
  }, [wordpressUrl]);

  return null;
}

function SitesRedirect({ wordpressUrl }) {
  // Redirect /sites to the WordPress URL to prevent redirect loops
  useEffect(() => {
    if (wordpressUrl) {
      window.location.href = wordpressUrl;
    } else {
      // Fallback to main site if WordPress URL is not configured
      window.location.href = "/";
    }
  }, [wordpressUrl]);

  return null;
}

function NotFound({ debugMode, setComponent }) {
  return (
    <>
      {debugMode === true
        ? console.log(
            "Page [",
            window.location.pathname,
            "] not found. Redirecting to main."
          )
        : null}
      <MainWindow setComponent={() => setComponent("ChildComponent1")} />
    </>
  );
}
